import React, { useContext } from "react";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import AppContext from "../../Context/AppContext";

const RolesTable = ({
  roles,
  loading,
  onCreate,
  onEdit,
  onDelete,
  onPermissions
}) => {
  const { applicationId, siteId } = useContext(AppContext);

  if (loading) return <p>Loading roles...</p>;
  if (!roles.length) return <p>No roles found</p>;

  const disabledTooltip = (
    <Tooltip id="role-disabled-tooltip">
      You cannot modify roles from a different application or site.
    </Tooltip>
  );

  return (
    <>
      <table className="table table-bordered table-hover">
        <thead>
          <tr>
            <th>Role ID</th>
            <th>Role Name</th>
            <th>Role Level</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {roles.map((role) => {
            const editable =
              role.applicationId === applicationId &&
              role.siteId === siteId;

            return (
              <tr key={role.roleId}>
                <td>{role.roleId}</td>
                <td>{role.roleName}</td>
                <td>{role.roleLevel}</td>
                <td>
                  <Dropdown>
                    <Dropdown.Toggle size="sm" variant="secondary">
                      Actions
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {/* EDIT */}
                      <OverlayTrigger
                        placement="left"
                        overlay={disabledTooltip}
                        trigger={editable ? [] : ["hover", "focus"]}
                      >
                        <span className="d-inline-block w-100">
                          <Dropdown.Item
                            disabled={!editable}
                            onClick={() => editable && onEdit(role)}
                            style={!editable ? { pointerEvents: "none" } : {}}
                          >
                            Edit
                          </Dropdown.Item>
                        </span>
                      </OverlayTrigger>

                      {/* DELETE */}
                      <OverlayTrigger
                        placement="left"
                        overlay={disabledTooltip}
                        trigger={editable ? [] : ["hover", "focus"]}
                      >
                        <span className="d-inline-block w-100">
                          <Dropdown.Item
                            id={`btnDeleteRole_${role.roleId}`}
                            disabled={!editable}
                            onClick={() => editable && onDelete(role)}
                            style={!editable ? { pointerEvents: "none" } : {}}
                          >
                            Delete
                          </Dropdown.Item>
                        </span>
                      </OverlayTrigger>

                      {/* PERMISSIONS (always enabled as per current logic) */}
                      <Dropdown.Item onClick={() => onPermissions(role)}>
                        Permissions
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};

export default RolesTable;
